import {
  ProductCategoryCreateMutationOptions,
  ProductCategoryUpdateMutationOptions,
  ProductCategoryDeleteMutationOptions,
  useProductCategoryCreateMutation as useApolloProductCategoryCreateMutation,
  useProductCategoryUpdateMutation as useApolloProductCategoryUpdateMutation,
  useProductCategoryDeleteMutation as useApolloProductCategoryDeleteMutation,
} from '@occc/graphql';

import { useMutation } from '../utils';

export const useProductCategoryCreateMutation = (
  baseOptions: ProductCategoryCreateMutationOptions,
) => useMutation(useApolloProductCategoryCreateMutation, baseOptions);

export const useProductCategoryUpdateMutation = (
  baseOptions: ProductCategoryUpdateMutationOptions,
) => useMutation(useApolloProductCategoryUpdateMutation, baseOptions);

export const useProductCategoryDeleteMutation = (
  baseOptions: ProductCategoryDeleteMutationOptions,
) => useMutation(useApolloProductCategoryDeleteMutation, baseOptions);
